export default __webpack_public_path__ + "static/media/noozai-logo-fullcolor.4669af77.png";